import type { IssueAttachment } from '../../types';
import { ISSUE_FILE_ACCEPT, ISSUE_FILE_HINT } from '../../utils/issueFiles';
import './IssueAttachmentsBlock.css';

type Props = {
  files: IssueAttachment[];
  canEdit?: boolean;
  uploading?: boolean;
  onOpen: (file: IssueAttachment, files: IssueAttachment[]) => void;
  onDelete?: (file: IssueAttachment) => void;
  onAdd?: (files: File[]) => void;
};

const IssueAttachmentsBlock = ({
  files,
  canEdit = false,
  uploading = false,
  onOpen,
  onDelete,
  onAdd,
}: Props) => {
  if (!canEdit && files.length === 0) return null;

  return (
    <div className="record-details-files">
      <span>Файлы</span>
      {canEdit && onAdd ? (
        <>
          <p className="record-details-files-hint">{ISSUE_FILE_HINT}</p>
          <label className="record-details-files-attach">
            {uploading ? 'Загрузка...' : 'Прикрепить'}
            <input
              type="file"
              accept={ISSUE_FILE_ACCEPT}
              multiple
              disabled={uploading}
              hidden
              onChange={(event) => {
                const picked = Array.from(event.target.files || []);
                event.target.value = '';
                if (picked.length > 0) onAdd(picked);
              }}
            />
          </label>
        </>
      ) : null}
      {files.length === 0 ? (
        canEdit ? <p className="record-details-files-empty">Нет файлов</p> : null
      ) : (
        <ul className="record-details-files-list">
          {files.map((file) => (
            <li key={file.id}>
              <button
                type="button"
                className="record-details-file-open"
                onClick={() => onOpen(file, files)}
              >
                {file.original_name || file.filename}
              </button>
              {canEdit && onDelete ? (
                <button
                  type="button"
                  className="record-details-file-delete"
                  onClick={() => onDelete(file)}
                >
                  Удалить
                </button>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default IssueAttachmentsBlock;
